// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"31":"1ed9b0c853560e4e","125":"c4c89378367d32ef","828":"f48f71fef9a22c88"}[chunkId] + ".js";
};